import { connect } from 'react-redux'
import { FirefoxButton } from '../../../Components/FirefoxButton'

const mapStateToProps = (state, params) => {
  return {
    children: state.localization.dictionary.login.loginFirefox
  }
}

const FirefoxButtonConnected = connect(
  mapStateToProps
)(FirefoxButton)

export {
  FirefoxButtonConnected as FirefoxButton
}



// WEBPACK FOOTER //
// ./client/Modules/AuthFirefox/containers/FirefoxButton.js